<template>
  <CCardBody>
    <CInputRadioGroup
      class="w-100 d-flex justify-content-between font-weight-bold"
      color="primary"
      custom
      :checked="check"
      :options="options"
      @update:checked="changePayPeriodToggle"
    />
    <CRow>
      <CCol class="ml-4 text-gray-500">{{ $t(`manageBalance.planSummary.saveWithAnnual`) }}</CCol>
      <CCol class="pl-3"></CCol>
    </CRow>
  </CCardBody>
</template>

<script>
export default {
  name: 'PayPeriod',
  data() {
    return {}
  },

  computed: {
    check() {
      const value = this.$store.state.balance.steps.package.packSelected.balanceRenewalPeriod == 1 ? 'addPlan' : 'oneShot'
      return this.options.filter((item) => item.value == value)[0].value
    },

    package() {
      return this.$store.state.balance.steps.package
    },

    options() {
      return [
        {
          value: 'addPlan',
          label: this.$t(`manageBalance.planSummary.addPlan`),
        },
        {
          value: 'oneShot',
          label: this.$t(`manageBalance.planSummary.oneShot`),
        },
      ]
    },
  },

  methods: {
    changePayPeriodToggle(value) {
      const DATA = this.handleSelected(value)
      this.$store.dispatch('balance/steps/updateInfoPropStep', { prop: 'package', data: DATA })
    },

    handleSelected(balanceRenewalPeriod) {
      const period = balanceRenewalPeriod == 'addPlan' ? 1 : null

      const mock = {
        packSelected: null,
        packsTypes: this.package.packsTypes,
      }

      mock.packSelected = this.package.packsTypes.filter((item) => item.balanceRenewalPeriod == period)[0]

      return mock || this.package
    },
  },
}
</script>

<style lang="scss">
.c-switch-primary .c-switch-slider {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
}

.switchPeriod {
  min-width: 400px;
  .text {
    word-break: break-word;
  }
}
</style>
